export const PersonalInformationPath = '/settings/personal-information';
export const SecurityPath = '/settings/security';
export const SubscriptionPath = '/settings/subscription';
export const BillingHistoryPath = '/settings/billing-history';
export const BILLING_HISTORY_ITEM_KEY = 'billing_history';
